import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { cookieUtils } from '../API/ApiService';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!cookieUtils.get('token'));
  const [isLoading, setIsLoading] = useState(false);
  const [isSdkValid, setIsSdkValid] = useState(false);
  const navigate = useNavigate();

  const checkToken = useCallback(() => {
    const token = cookieUtils.get('token');
    if (!token) {
      setIsAuthenticated(false);
      localStorage.clear();
      navigate('/login', { replace: true });
      return false;
    }
    return true;
  }, [navigate]);

  const verifyAuth = useCallback(async () => {
    setIsLoading(true);
    try {
      const token = cookieUtils.get('token');
      if (!token) {
        setIsAuthenticated(false);
        return false;
      }

      await api.get('/profile');
      setIsAuthenticated(true);
      return true;
    } catch (error) {
      setIsAuthenticated(false);
      return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const validateSdkToken = useCallback(async () => {
    try {
      const sdkToken = cookieUtils.get('sdkToken');
      const appSpecificToken = cookieUtils.get('appSpecificToken');
      if (!sdkToken) {
        setIsSdkValid(false);
        cookieUtils.delete('sdkToken');
        return false;
      }

      const response = await api.validateToken({fesToken:sdkToken,appSpecificToken});
      const isValid = response?.data?.expiredAt && new Date(response.data.expiredAt) > new Date();
      setIsSdkValid(isValid);
      return isValid;
    } catch (error) {
      setIsSdkValid(false);
      return false;
    }
  }, []);

  return {
    isAuthenticated,
    isLoading,
    isSdkValid,
    verifyAuth,
    validateSdkToken,
    checkToken
  };
};